import { cnpj as cnpjValidate } from "cpf-cnpj-validator";

export const cnpjValidator = (cnpj: string) => cnpjValidate.isValid(cnpj);
